const product = {
	categoryMenu: function () {
		$(".box-category-menu-list li[class*='has-children']>a").on("click", function (e) {
			e.preventDefault();
			$(this).next().slideToggle().parent().toggleClass("current").siblings().removeClass("current").find("ul").slideUp();
		});
	},
	menuFilter: function () {
		$(".button-menu-filter").on("click", function () {
			$(".box-menu-filter").toggleClass("active");
			$(this).toggleClass("active");
		});
	},
	init: function () {
		this.categoryMenu();
		this.menuFilter();
	},
};
export default product;
